import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModelTranslatePipe } from './pipes/model-translate.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { CdnImgSourcePipe } from './pipes/cdn-img-source.pipe';
import { currentUserInRolePipe } from './pipes/current-user-in-roles.pipe';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IsDateInRangePipe } from './pipes/is-date-in-range.pipe';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyPanelWrapperComponent } from './components/formly/formly-panel-wrapper.component';
import { NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';
import { FormlyRepeatSectionTypeComponent } from './components/formly/formly-repeat-section-type.component';
import { WidgetPickupDisplayAddressComponent } from './components/widget-pickup-display-address/widget-pickup-display-address.component';


@NgModule({
  declarations: [
    ModelTranslatePipe,
    CdnImgSourcePipe,
    currentUserInRolePipe,
    IsDateInRangePipe,
    FormlyPanelWrapperComponent,
    FormlyRepeatSectionTypeComponent,
    WidgetPickupDisplayAddressComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgbCollapseModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'repeat', component: FormlyRepeatSectionTypeComponent
        },
        {
          name: 'number',
          extends: 'input',
          defaultOptions: {
            props: {
              type: 'number',
              label: 'Default Number Field',
            },
          },
        },
        {
          name: 'hidden',
          extends: 'input',
          defaultOptions: {
            props: {
              type: 'hidden',
              label: '',
            },
          },
        },
      ],
      wrappers: [{ name: 'panel', component: FormlyPanelWrapperComponent }]
    }),
    FormlyBootstrapModule
  ],
  exports: [
    ModelTranslatePipe,
    CdnImgSourcePipe,
    currentUserInRolePipe,
    TranslateModule,
    IsDateInRangePipe,
    FormlyBootstrapModule,
    FormlyModule,
    FormlyRepeatSectionTypeComponent,
    WidgetPickupDisplayAddressComponent
  ]
})
export class SharedModule { }
